<app-devops-placeholder-card
  titleKey="liveDashboard.devops.buildsTitle"
  descriptionKey="liveDashboard.devops.description"
/>
